import React, { Component } from 'react';
import Grid from '@material-ui/core/Grid';
import { Report } from '../components/Report';
import { ReportRevisionSend } from '../components/ReportRevisionSend';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import CircularProgress from '@material-ui/core/CircularProgress';
import Button from '@material-ui/core/Button'
import CheckIcon from '@material-ui/icons/Check';
import HistoryIcon from '@material-ui/icons/History';

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

//import Moment from 'react-moment';
import 'moment-timezone';
import moment from 'moment'

export class CycleOfTheReportPage extends Component {

    constructor(props) {
        super(props);
        this.state = {
            waitingMesagge: "Loading ...",
            waiting: true,
            loading: true,
            pageRevisions: [],
            pageMissionDetails: [],
            pageData: {},
            missionId: "",
            files: [],
            notAuthorized: false,
            userType: -1,
            userRoleMission: -1,
            userListAndRoleMission: [],
            countOfRevision: 0,
            isFetching: false,
            submittingUserID: -1,
            submittingUser: null,
            submittingDate: new Date(),
            submittingDateISO: moment(new Date()).format('DD.MM.YYYY hh:mm:ss'),
            plannedDateInput: new Date(),
            plannedDateInputISO: moment(new Date()).format('DD.MM.YYYY hh:mm:ss'),
            postAsUser: null,
            typeOfROM: -1,
            filenameMQ: "",
            filenameMR: "",
            filenameNS: "",
            filenameNW: "",
            filenameAdditional: "",
            lastRevisionType: -1,
        };
    }

    getUserType = () => {
        let pageData = {
            operation: "GetUserType"
        };

        fetch(global.variables.API_USEROPERATIONS_GETUSERTYPE, {
            method: "POST",
            headers: {
                Authorization: "Bearer " + localStorage.getItem("authtoken"),
                Accept: "application/json",
                "Content-Type": "application/json"
            },
            body: JSON.stringify(pageData)
        })
            .then(response => response.json())
            .then(result => {
                console.log(result);

                this.setState({ userType: result.userType });
            });
    }

    handleFileInputChange = event => {
        var filesvar = this.state.files;
        filesvar.push({
            filename: event.target.name,
            fileblob: event.target.files[0]
        });
        this.setState({ files: filesvar });

        console.log("event.target.name " + event.target.name);

        if (event.target.name === "fileMQ") {
            this.setState({ filenameMQ: event.target.files[0].name });
        }
        if (event.target.name === "fileMR") {
            this.setState({ filenameMR: event.target.files[0].name });
        }
        if (event.target.name === "fileNS") {
            this.setState({ filenameNS: event.target.files[0].name });
        }
        if (event.target.name === "fileNW") {
            this.setState({ filenameNW: event.target.files[0].name });
        }
        if (event.target.name === "fileAdditional") {
            this.setState({ filenameAdditional: event.target.files[0].name });
        }
    };

    handleChangeDate = (name, value) => {
        console.log(name);
        console.log(value);
        console.log(moment(new Date(value)).format('DD.MM.YYYY hh:mm:ss'));

        //moment(new Date()).format('DD.MM.YYYY hh:mm:ss') 
        //this.setState({ [name]: new Date(value) });
        this.setState({ [name]: new Date(moment(value).format('YYYY-MM-DD')) });
        //this.setState({ [name + "ISO"]: moment(new Date(value)).format('DD/MM/YYYY hh:mm:ss') });
        //this.setState({ [name]: moment(new Date(value)).format('DD/MM/YYYY hh:mm:ss') });
    };

    handleChangeSubmitDate = (name, value) => {
        console.log(name);
        console.log(value);
        console.log(moment(new Date(value)).format('DD.MM.YYYY hh:mm:ss'));

        if (name === "submittingDate") {
            this.setState({ ["submittingDate"]: new Date(value) });
            this.setState({ ["submittingDateISO"]: moment(new Date(value)).format('DD.MM.YYYY hh:mm:ss') });
        } else if (name === "plannedDateInput") {
            this.setState({ ["plannedDateInput"]: new Date(value) });
            this.setState({ ["plannedDateInputISO"]: moment(new Date(value)).format('DD.MM.YYYY hh:mm:ss') });
        }

        ////moment(new Date()).format('DD/MM/YYYY hh:mm:ss') 
        //this.setState({ ["submittingDate"]: new Date(value) });
        ////this.setState({ [name + "ISO"]: moment(new Date(value)).format('DD.MM.YYYY hh:mm:ss') });
        //this.setState({ ["submittingDateISO"]: moment(new Date(value)).format('DD.MM.YYYY hh:mm:ss') });
    };

    sendRevision = async (e) => {
        //console.log("Send Revision");
        //console.log(this.state);

        await this.setState({ isFetching: true });

        var formData = new FormData();

        if (this.state.files && this.state.files.length > 0) {
            var filesarray = this.state.files;
            for (var i = 0; i < filesarray.length; i++) {
                //console.log("Appending files " + filesarray[i].filename);
                formData.append(filesarray[i].filename, filesarray[i].fileblob);
            }
        }

        var postData = this.state;
        Object.keys(postData).forEach((key, value) => {
            if (key !== "files") {
                formData.append(key, postData[key]);
            }
        });

        // This is for test fetch, URL will be changed
        await fetch(global.variables.API_REPORTCYCLE_SENDREVISION, {
            method: "POST",
            headers: {
                Authorization: "Bearer " + localStorage.getItem("authtoken"),
                //Accept: "application/json",
                //"Content-Type": "application/json"
            },
            body: formData
        })
            .then(response => response.json())
            .then(result => {
                console.log(result);

                if (result.resultstate === 0) {
                    toast.success("Success!", {
                        position: toast.POSITION.BOTTOM_RIGHT
                    });

                    this.setState({ revisionComment: "" });

                } else {
                    toast.error("Failed!", {
                        position: toast.POSITION.BOTTOM_RIGHT
                    });
                }

                this.setState({
                    files: [],
                    filenameMQ: "",
                    filenameMR: "",
                    filenameNS: "",
                    filenameNW: "",
                    filenameAdditional: ""
                });

                this.pageLoad();
            });

        await this.setState({ isFetching: false });
    };


    submitQCRevisionAndApprove = async (e) => {
        //console.log("Send Revision");
        //console.log(this.state);

        await this.setState({ isFetching: true });

        var formData = new FormData();

        if (this.state.files && this.state.files.length > 0) {
            var filesarray = this.state.files;
            for (var i = 0; i < filesarray.length; i++) {
                //console.log("Appending files " + filesarray[i].filename);
                formData.append(filesarray[i].filename, filesarray[i].fileblob);
            }
        }

        var postData = this.state;
        Object.keys(postData).forEach((key, value) => {
            if (key !== "files") {
                formData.append(key, postData[key]);
            }
        });

        // This is for test fetch, URL will be changed
        await fetch(global.variables.API_REPORTCYCLE_SENDQCREVISIONWITHEDITANDAPPROVE, {
            method: "POST",
            headers: {
                Authorization: "Bearer " + localStorage.getItem("authtoken"),
                //Accept: "application/json",
                //"Content-Type": "application/json"
            },
            body: formData
        })
            .then(response => response.json())
            .then(result => {
                console.log(result);

                if (result.resultstate === 0) {
                    toast.success("Success!", {
                        position: toast.POSITION.BOTTOM_RIGHT
                    });

                    this.setState({ revisionComment: "" });

                } else {
                    toast.error("Failed!", {
                        position: toast.POSITION.BOTTOM_RIGHT
                    });
                }

                this.setState({
                    files: [],
                    filenameMQ: "",
                    filenameMR: "",
                    filenameNS: "",
                    filenameNW: "",
                    filenameRS: "",
                    filenameAdditional: ""
                });

                this.pageLoad();
            });

        await this.setState({ isFetching: false });
    };

    commentOnChange = (e) => {
        //console.log("Comment On Change: " + e.target.name + " " + e.target.value);
        //console.log(e)
        e.persist();
        this.setState({ [e.target.name]: e.target.value });
    };

    pageLoad = () => {
        this.setState({
            loading: true,
            waitingMesagge: "Loading ..."
        });

        fetch(global.variables.API_REPORTCYCLE_GETREVISION, {
            method: "POST",
            headers: {
                Authorization: "Bearer " + localStorage.getItem("authtoken"),
                Accept: "application/json",
                "Content-Type": "application/json"
            },
            body: JSON.stringify(this.state)
        })
            .then(response => response.json())
            .then(result => {
                console.log(result);

                if (result.resultstate === 2) {
                    this.setState({ notAuthorized: true });
                } else {

                    console.log("md: ");
                    console.log(result.missiondetails);

                    this.setState({
                        pageRevisions: result.revisions,
                        pageMissionDetails: result.missiondetails,
                        pageData: result
                    });

                    this.setState({
                        waitingMesagge: result.revisionWaitingMessage,
                        waiting: result.revisionIsWaiting,
                        isApprovedQC: result.isApprovedQC,
                        isApprovedQA: result.isApprovedQA
                    });

                    if (result.revisions.length > 0) {
                        this.setState({
                            lastRevisionType: result.revisions[result.revisions.length - 1].revisionType
                        });
                    }

                    this.setState({
                        loading: false,
                        countOfRevision: result.revisions.length
                    });

                }
            });
    };

    async componentDidMount() {


        let pageTokenAuthData = {
            operation: "AuthCheckToken"
        };

        await fetch(global.variables.API_CHECKTOKEN, {
            method: "POST",
            headers: {
                Authorization: "Bearer " + localStorage.getItem("authtoken"),
                Accept: "application/json",
                "Content-Type": "application/json"
            },
            body: JSON.stringify(pageTokenAuthData)
        })
            .then(response => response.json())
            .then(result => {
                if (result.resultstate > 0 ||
                    result.authresp === 2) {
                    window.location.href = "/login";
                }
            }).catch(() => {
                window.location.href = "/login";
            });

        await this.setState({
            missionId: this.props.match.params.id,
            selectedmissionid: this.props.match.params.id
        });
        //console.log("missionId " + this.state.missionId);

        //let pageData = { fkMissionID: this.state.missionId };

        await this.pageLoad();

        await this.getUserType();

        await this.getUsersRoleForMission();

        await this.getUsersListAndRoleForMission();

        await this.getTypeOfRom();
    }

    getUsersRoleForMission = async () => {
        await fetch(global.variables.API_ASSIGNMISSION_LOADPAGE_GETUSERSROLEFORMISSON, {
            method: "POST",
            headers: {
                Authorization: "Bearer " + localStorage.getItem("authtoken"),
                Accept: "application/json",
                "Content-Type": "application/json"
            },
            body: JSON.stringify(this.state)
        })
            .then(response => response.json())
            .then(result => {
                console.log(result);

                if (result.resultstate === 0) {
                    this.setState({
                        userRoleMission: result.userRoleMission
                    });
                }
            });
    }

    getUsersListAndRoleForMission = async () => {
        await fetch(global.variables.API_ASSIGNMISSION_LOADPAGE_GETLISTOFUSERSANDROLEFORMISSON, {
            method: "POST",
            headers: {
                Authorization: "Bearer " + localStorage.getItem("authtoken"),
                Accept: "application/json",
                "Content-Type": "application/json"
            },
            body: JSON.stringify(this.state)
        })
            .then(response => response.json())
            .then(result => {
                console.log(result);

                if (result.resultstate === 0) {
                    this.setState({
                        userListAndRoleMission: result.userListAndRoleMission
                    });
                }
            });
    }

    getTypeOfRom = async () => {

        await this.setState({
            missionId: this.props.match.params.id
        });

        await fetch(global.variables.API_PROJECTDETAILS_GETTYPEOFROM, {
            method: "POST",
            headers: {
                Authorization: "Bearer " + localStorage.getItem("authtoken"),
                Accept: "application/json",
                "Content-Type": "application/json"
            },
            body: JSON.stringify(this.state)
        })
            .then(response => response.json())
            .then(result => {
                console.log(result);

                this.setState({
                    typeOfROM: result.typeOfROM
                });
            });
    }

    extendDeadline = async () => {
        //console.log("Extending Deadline");

        await this.setState({ isFetching: true });

        await fetch(global.variables.API_REPORTCYCLE_EXTENDDEADLINE, {
            method: "POST",
            headers: {
                Authorization: "Bearer " + localStorage.getItem("authtoken"),
                Accept: "application/json",
                "Content-Type": "application/json"
            },
            body: JSON.stringify({ missionId: this.state.missionId })
        })
            .then(response => response.json())
            .then(result => {
                console.log(result);

                if (result.resultstate === 2) {
                    this.setState({ notAuthorized: true });
                } else {

                    if (result.resultstate === 0) {
                        toast.success("Success!", {
                            position: toast.POSITION.BOTTOM_RIGHT
                        });
                    } else {
                        toast.error("Failed!", {
                            position: toast.POSITION.BOTTOM_RIGHT
                        });
                    }

                    this.pageLoad();
                }
            });

        //await this.pageLoad();
        await this.setState({ isFetching: false });
    }

    approveDraft = async () => {
        //console.log("Approving Draft");

        await this.setState({ isFetching: true });

        await fetch(global.variables.API_REPORTCYCLE_APPROVEDRAFT, {
            method: "POST",
            headers: {
                Authorization: "Bearer " + localStorage.getItem("authtoken"),
                Accept: "application/json",
                "Content-Type": "application/json"
            },
            body: JSON.stringify({ missionId: this.state.missionId })
        })
            .then(response => response.json())
            .then(result => {
                console.log(result);

                if (result.resultstate === 2) {
                    this.setState({ notAuthorized: true });
                } else {

                    if (result.resultstate === 0) {
                        toast.success("Success!", {
                            position: toast.POSITION.BOTTOM_RIGHT
                        });
                    } else {
                        toast.error("Failed!", {
                            position: toast.POSITION.BOTTOM_RIGHT
                        });
                    }

                    this.pageLoad();
                }
            });

        await this.setState({ isFetching: false });
    }

    approveDraftPastCycle = async () => {
        //console.log("Approving Draft");

        await this.setState({ isFetching: true });

        await fetch(global.variables.API_REPORTCYCLE_APPROVEDRAFTPASTCYCLE, {
            method: "POST",
            headers: {
                Authorization: "Bearer " + localStorage.getItem("authtoken"),
                Accept: "application/json",
                "Content-Type": "application/json"
            },
            body: JSON.stringify({ missionId: this.state.missionId })
        })
            .then(response => response.json())
            .then(result => {
                console.log(result);

                if (result.resultstate === 2) {
                    this.setState({ notAuthorized: true });
                } else {

                    if (result.resultstate === 0) {
                        toast.success("Success!", {
                            position: toast.POSITION.BOTTOM_RIGHT
                        });

                    } else {
                        toast.error("Failed!", {
                            position: toast.POSITION.BOTTOM_RIGHT
                        });
                    }

                    this.pageLoad();
                }
            });

        await this.setState({ isFetching: false });
    }

    preApproveLastCheckSendEmail = async () => {

        await this.setState({ isFetching: true });

        var pageData = {
            operation: "SendEmail",
            missionId: this.state.missionId
        };

        await fetch(global.variables.API_REPORTCYCLE_PREAPPROVELASTCHECKSENDEMAIL, {
            method: "POST",
            headers: {
                Authorization: "Bearer " + localStorage.getItem("authtoken"),
                Accept: "application/json",
                "Content-Type": "application/json"
            },
            body: JSON.stringify(pageData)
        })
            .then(response => response.json())
            .then(result => {
                console.log(result);

                if (result.resultstate === 0) {
                    toast.success("Success!", {
                        position: toast.POSITION.BOTTOM_RIGHT
                    });
                } else {
                    toast.error("Failed!", {
                        position: toast.POSITION.BOTTOM_RIGHT
                    });
                }
            });

        await this.setState({ isFetching: false });
    }

    handlePostAsUserChange = (e, v) => {
        e.persist();
        if (v !== undefined & v !== null) {
            this.setState({
                submittingUserID: v.idLoginCredentials,
                submittingUser: v,
                postAsUser: v
            });
        } else {
            this.setState({
                submittingUserID: -1,
                submittingUser: null,
                postAsUser: null
            });
        }
    }

    render() {

        const {
            userType,
            userRoleMission,
            countOfRevision,
            isFetching,
            submittingDate,
            postAsUser,
            userListAndRoleMission,
            typeOfROM,
            plannedDateInput,
            pageMissionDetails,
        } = this.state;

        if (this.state.isApprovedQC &&
            this.state.isApprovedQA) {

            //if (userType === 2) {
            //    this.props.history.push("/templatefilling/" + this.state.missionId);

            //    return (
            //        <p>Redirecting...</p>
            //    );
            //} else {
            //    return (
            //        <p>You are not authorized</p>
            //    );
            //}

            if (userType !== 2) {
                this.props.history.push("/templatefilling/" + this.state.missionId);

                return (
                    <p>You are not authorized</p>
                );
            }
        } else if (this.state.notAuthorized) {
            this.props.history.push("/templatefilling/" + this.state.missionId);

            return (
                <p>You are not authorized</p>
            );
        } else {


        }

        //console.log("pageRevisions " + this.state.pageRevisions.length);

        //if (this.state.pageRevisions.length === 0) {
        //    console.log("hi");
        //} else {
        //    console.log("nohi");
        //}

        //console.log("PD: ");
        //console.log(this.state.pageMissionDetails[0]);

        return (
            <Grid container spacing={3} >
                <Grid>
                    <ToastContainer />
                </Grid>

                {
                    //<Grid item xs={12}>
                    //    <p>Project Title: {this.state.pageMissionDetails[0].ProjectTitle}</p>
                    //    <p>Project Number: {this.state.pageMissionDetails[0].ProjectNumber}</p>
                    //    <p>Mission Number: {this.state.pageMissionDetails[0].MissionNumber}</p>
                    //</Grid>
                }

                {
                    !this.state.waiting & !this.state.loading ?

                        <Grid item xs={12}>
                            <p>Project Title: {this.state.pageMissionDetails[0] != undefined ? this.state.pageMissionDetails[0].ProjectTitle : ""}</p>
                            <p>Project Number: {this.state.pageMissionDetails[0] != undefined ? this.state.pageMissionDetails[0].ProjectNumber : ""}</p>
                            <p>Mission Number: {this.state.pageMissionDetails[0] != undefined ? this.state.pageMissionDetails[0].MissionNumber : ""}</p>
                        </Grid>

                        :

                        ""
                }

                {
                    //<Grid item xs={12}>
                    //    <Report
                    //        title="Monitor's Input (MON1)"
                    //        comment="This is a comment"
                    //        actualDate="01/01/20"
                    //        plannedDate="01/01/20"
                    //    />

                    //    {
                    //        this.state.isApprovedQC && this.state.isApprovedQA ? <span>This Project is Draft Approved</span> : null
                    //    }
                    //</Grid>
                }

                {
                    //<Grid item xs={12} className="mt-2">
                    //    <Report
                    //        title="Quality Control Input (QC1)"
                    //        comment="Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse sed congue massa. Vestibulum nibh ligula, pharetra non luctus ac, malesuada non sem. Pellentesque ultrices, elit ut pharetra pulvinar, nunc tortor blandit leo, vitae pulvinar purus metus quis ipsum. Phasellus ut tellus augue. Aliquam molestie pulvinar dolor eu malesuada. Aliquam sagittis ultrices nisi, at pulvinar lorem facilisis at. Fusce eu condimentum est. Sed congue libero nisl, vitae cursus dui malesuada ut. Proin eleifend malesuada lorem, nec accumsan nisi placerat ut. Nullam fringilla leo semper hendrerit imperdiet. Fusce a suscipit nulla, quis elementum nibh. Fusce a leo vitae nisl ullamcorper venenatis sit amet et velit. Sed posuere, libero non aliquam varius, leo arcu gravida augue, a luctus mi lorem quis erat. Phasellus consequat tortor quis augue faucibus dictum. Morbi malesuada viverra lacus sit amet aliquet. Fusce et nulla est. Proin interdum nulla id nisi gravida dictum. Proin congue purus ut leo egestas, in condimentum tellus mattis. Sed id ipsum odio. Proin placerat lacus magna, non vehicula diam sollicitudin quis. Donec diam ligula, faucibus quis risus nec, facilisis suscipit nisl. Cras imperdiet ante eget arcu pretium cursus. Nullam quis ultrices felis, sed fermentum lacus. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus quis justo nunc. In ut hendrerit erat. Donec consequat quam sed arcu condimentum fermentum. Maecenas pharetra id lacus efficitur accumsan. Pellentesque egestas, dui non suscipit pretium, nisi turpis feugiat quam, quis consequat odio justo a ligula. In blandit purus at elementum scelerisque. Pellentesque sollicitudin eget lacus sit amet laoreet. Fusce sagittis orci sed enim maximus cursus. Praesent tempor neque dignissim congue consequat. Duis consequat egestas dignissim. Donec vehicula magna magna, vel feugiat tortor euismod ac. Proin dui turpis, aliquet vel dui egestas, auctor scelerisque metus. Nam sodales feugiat augue, ac sodales odio porttitor vitae. Aenean nisl ex, eleifend sed lacinia ut, tincidunt id dui. Praesent sed tincidunt lorem. Nam urna sem, accumsan eget justo a, porta lobortis sapien. Pellentesque volutpat pretium metus sit amet tincidunt. Ut sit amet egestas eros."
                    //        actualDate="01/01/20"
                    //        plannedDate="01/01/20"
                    //    />
                    //</Grid>
                    //<Grid item xs={12} className="mt-2">
                    //    <Report
                    //        title="Monitor's Input (MON2QC1)"
                    //        comment="Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse sed congue massa. Vestibulum nibh ligula, pharetra non luctus ac, malesuada non sem. Pellentesque ultrices, elit ut pharetra pulvinar, nunc tortor blandit leo, vitae pulvinar purus metus quis ipsum. Phasellus ut tellus augue. Aliquam molestie pulvinar dolor eu malesuada. Aliquam sagittis ultrices nisi, at pulvinar lorem facilisis at. Fusce eu condimentum est. Sed congue libero nisl, vitae cursus dui malesuada ut. Proin eleifend malesuada lorem, nec accumsan nisi placerat ut. Nullam fringilla leo semper hendrerit imperdiet. Fusce a suscipit nulla, quis elementum nibh. Fusce a leo vitae nisl ullamcorper venenatis sit amet et velit. Sed posuere, libero non aliquam varius, leo arcu gravida augue, a luctus mi lorem quis erat. Phasellus consequat tortor quis augue faucibus dictum. Morbi malesuada viverra lacus sit amet aliquet. Fusce et nulla est. Proin interdum nulla id nisi gravida dictum. Proin congue purus ut leo egestas, in condimentum tellus mattis. Sed id ipsum odio. Proin placerat lacus magna, non vehicula diam sollicitudin quis. Donec diam ligula, faucibus quis risus nec, facilisis suscipit nisl. Cras imperdiet ante eget arcu pretium cursus. Nullam quis ultrices felis, sed fermentum lacus. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus quis justo nunc. In ut hendrerit erat. Donec consequat quam sed arcu condimentum fermentum. Maecenas pharetra id lacus efficitur accumsan. Pellentesque egestas, dui non suscipit pretium, nisi turpis feugiat quam, quis consequat odio justo a ligula. In blandit purus at elementum scelerisque. Pellentesque sollicitudin eget lacus sit amet laoreet. Fusce sagittis orci sed enim maximus cursus. Praesent tempor neque dignissim congue consequat. Duis consequat egestas dignissim. Donec vehicula magna magna, vel feugiat tortor euismod ac. Proin dui turpis, aliquet vel dui egestas, auctor scelerisque metus. Nam sodales feugiat augue, ac sodales odio porttitor vitae. Aenean nisl ex, eleifend sed lacinia ut, tincidunt id dui. Praesent sed tincidunt lorem. Nam urna sem, accumsan eget justo a, porta lobortis sapien. Pellentesque volutpat pretium metus sit amet tincidunt. Ut sit amet egestas eros."
                    //        actualDate="01/01/20"
                    //        plannedDate="01/01/20"
                    //    />
                    //</Grid>
                }

                {

                    this.state.pageRevisions.map((item, i) => {

                        var fileMQLink = null;
                        var fileMRLink = null;
                        var fileNSLink = null;
                        var fileNWLink = null;
                        var fileAdditionalLink = null;
                        var revisionComment = "";

                        //console.log("rev " + i + " " + item.fileMQ + " " + item.fileMR);

                        if (item.fileMQ !== "" &
                            item.fileMQ !== undefined) {
                            fileMQLink = "/api/FileUploadDownload/DownloadFileId/" + btoa(localStorage.getItem("authtoken")) + "/" + item.fileMQ
                        }

                        if (item.fileMR !== "" &
                            item.fileMR !== undefined) {
                            fileMRLink = "/api/FileUploadDownload/DownloadFileId/" + btoa(localStorage.getItem("authtoken")) + "/" + item.fileMR
                        }

                        if (item.fileNS !== "" &
                            item.fileNS !== undefined) {
                            fileNSLink = "/api/FileUploadDownload/DownloadFileId/" + btoa(localStorage.getItem("authtoken")) + "/" + item.fileNS
                        }

                        if (item.fileNW !== "" &
                            item.fileNW !== undefined) {
                            fileNWLink = "/api/FileUploadDownload/DownloadFileId/" + btoa(localStorage.getItem("authtoken")) + "/" + item.fileNW
                        }

                        if (item.fileAdditional !== "" &
                            item.fileAdditional !== undefined) {
                            fileAdditionalLink = "/api/FileUploadDownload/DownloadFileId/" + btoa(localStorage.getItem("authtoken")) + "/" + item.fileAdditional
                        }

                        if (item.revisionComment !== null &
                            item.revisionComment !== undefined) {
                            revisionComment = "" + item.revisionComment
                        }

                        return (
                            <Grid item xs={12} className="mt-2" key={i}>
                                <Report
                                    title={item.revisionName}
                                    comment={revisionComment}
                                    actualDate={item.revisionSubmitDate}
                                    plannedDate={item.revisionDueDate}
                                    mqFile={fileMQLink}
                                    mrFile={fileMRLink}
                                    nsFile={fileNSLink}
                                    nwFile={fileNWLink}
                                    additionalFile={fileAdditionalLink}
                                    isApprovedQC={this.state.isApprovedQC}
                                />
                            </Grid>
                        )
                    })

                }

                {
                    !this.state.waiting & !this.state.loading &&
                        !this.state.isApprovedQA ?
                        //true ?

                        <Grid item xs={12} className="mt-2">
                            <ReportRevisionSend
                                title="Revision"
                                //actualDate="01/01/20"
                                plannedDate={this.state.pageData.plannednextduedate}
                                onChangeCommentText={this.commentOnChange.bind(this)}
                                sendRevision={this.sendRevision.bind(this)}
                                onChangeMQ={this.handleFileInputChange.bind(this)}
                                onChangeMR={this.handleFileInputChange.bind(this)}
                                onChangeNS={this.handleFileInputChange.bind(this)}
                                onChangeNW={this.handleFileInputChange.bind(this)}
                                onChangeAdditional={this.handleFileInputChange.bind(this)}
                                filenameMQ={this.state.filenameMQ}
                                filenameMR={this.state.filenameMR}
                                filenameNS={this.state.filenameNS}
                                filenameNW={this.state.filenameNW}
                                filenameAdditional={this.state.filenameAdditional}
                                userRole={userListAndRoleMission}
                                countOfRevision={countOfRevision}
                                isFetching={isFetching}
                                submittingDate={submittingDate}
                                plannedDateInput={plannedDateInput}
                                onChangeDate={(name, value) =>
                                    this.handleChangeSubmitDate(name, value)
                                }
                                postAsUser={postAsUser}
                                onPostAsUserChange={this.handlePostAsUserChange.bind(this)}
                                userRoleMission={userRoleMission}
                                userType={userType}
                                typeOfROM={typeOfROM}
                            />
                        </Grid>

                        : null
                }

                {
                    //this.state.waiting & !this.state.loading & userRoleMission === 2 & !this.state.isApprovedQC ?

                    //    <Grid item xs={12}>
                    //        <Button variant="outlined" color="primary" fullWidth
                    //            onClick={this.extendDeadline.bind(this)}
                    //            style={{ padding: "14px 0", fontWeight: "300" }}
                    //            disabled={isFetching ? true : false}>
                    //            <HistoryIcon style={{ paddingRight: "8px" }} /> Extend Deadline For Monitor
                    //        </Button>
                    //    </Grid>

                    //    : null
                }

                {
                    //!this.state.waiting & !this.state.loading & userRoleMission === 5 ?

                    //    <Grid item xs={6}>
                    //        <Button variant="outlined" color="primary" fullWidth
                    //            onClick={this.preApproveLastCheckSendEmail.bind(this)}
                    //            style={{ background: "#3647a7", color: "#ffffff", padding: "14px 0", fontWeight: "300" }}
                    //            disabled={isFetching ? true : false}>
                    //            <CheckIcon style={{ paddingRight: "8px" }} /> QA Approval and Send Email
                    //        </Button>
                    //    </Grid>

                    //    : null
                }

                {
                    !this.state.waiting & !this.state.loading & userRoleMission === 5 &&
                        this.state.isApprovedQC && !this.state.isApprovedQA ?

                        <Grid item xs={12}>
                            <Button variant="outlined" color="primary" fullWidth
                                onClick={this.approveDraft.bind(this)}
                                style={{ background: "#3647a7", color: "#ffffff", padding: "14px 0", fontWeight: "300" }}
                                disabled={isFetching ? true : false}>
                                <CheckIcon style={{ paddingRight: "8px" }} /> Approve Draft Report
                            </Button>
                        </Grid>

                        : null
                }

                {
                    !this.state.waiting & !this.state.loading & userRoleMission === 2 && this.state.lastRevisionType != 5 &&
                        !this.state.isApprovedQC && !this.state.isApprovedQA ?

                        <Grid item xs={12}>
                            <Button variant="outlined" color="primary" fullWidth
                                onClick={this.approveDraft.bind(this)}
                                style={{ background: "#3647a7", color: "#ffffff", padding: "14px 0", fontWeight: "300" }}
                                disabled={isFetching ? true : false}>
                                <CheckIcon style={{ paddingRight: "8px" }} /> Approve Draft Report
                            </Button>
                        </Grid>

                        : null
                }

                {
                    !this.state.waiting & !this.state.loading & userType === 2 && userRoleMission === -1 &&
                        !this.state.isApprovedQC && !this.state.isApprovedQA && this.state.pageRevisions.length !== 0 ?

                        <Grid item xs={12}>
                            <Button variant="outlined" color="primary" fullWidth
                                onClick={this.approveDraftPastCycle.bind(this)}
                                style={{
                                    background: "#3647a7",
                                    color: "#ffffff",
                                    padding: "14px 0",
                                    fontWeight: "300"
                                }}
                                disabled={isFetching || this.state.pageRevisions.length === 0 ? true : false}
                            >
                                <CheckIcon style={{ paddingRight: "8px" }} /> Approve Draft Report For a Past Cycle
                                </Button>
                        </Grid>

                        : null
                }

                {
                    //!this.state.waiting & !this.state.loading & userRoleMission === 2 && this.state.lastRevisionType == 5 &&
                    //    !this.state.isApprovedQC && !this.state.isApprovedQA ?

                    !this.state.waiting & !this.state.loading & userRoleMission === 2 &&
                        !this.state.isApprovedQC && !this.state.isApprovedQA ?

                        <Grid item xs={12}>
                            <Button variant="outlined" color="primary" fullWidth
                                onClick={this.submitQCRevisionAndApprove.bind(this)}
                                style={{
                                    background: "#3647a7",
                                    color: "#ffffff",
                                    padding: "14px 0",
                                    fontWeight: "300"
                                }}
                                disabled={isFetching ? true : false}
                            >
                                <CheckIcon style={{ paddingRight: "8px" }} /> Send Revision And Approve Draft Report
                            </Button>
                        </Grid>

                        : null
                }

                {
                    //<Grid xs={12} item style={{ textAlign: "center" }}>
                    //    <FormControlLabel
                    //        control={
                    //            <Checkbox
                    //                //color="green[400]"
                    //                color="primary"
                    //                value="checkedG"
                    //            />
                    //        }
                    //        label="APPROVE DRAFT REPORT"
                    //    />
                    //</Grid>
                }

                {
                    //<Grid item xs={12} className="mt-2">
                    //    <Button onClick={() => {
                    //        this.setState({ waitingMesagge: "Waiting for QC Response...", waiting: true })

                    //    }}>QC Response Bekleniyor</Button>
                    //    <Button onClick={() => {
                    //        this.setState({ waitingMesagge: "Waiting for MON Response...", waiting: true })

                    //    }}>MON Response Bekleniyor</Button>
                    //    <Button onClick={() => {
                    //        this.setState({ waiting: false })

                    //    }}>Response Beklenmiyor</Button>
                    //</Grid>
                }

                <Grid item xs={12} className="mt-2" style={{ textAlign: "center", display: this.state.waiting ? "block" : "none" }}>
                    <CircularProgress /> {this.state.waitingMesagge}
                </Grid>

                {
                    this.state.isApprovedQC &&
                        this.state.isApprovedQA &&
                        userType === 2 ?

                        <Grid item xs={12} style={{ marginTop: "100px" }}>
                            <Button variant="outlined" color="primary" fullWidth
                                href={"/templatefilling/" + this.state.missionId}
                                style={{ background: "#3647a7", color: "#ffffff", padding: "14px 0", fontWeight: "300" }}
                                disabled={isFetching ? true : false}>
                                <CheckIcon style={{ paddingRight: "8px" }} /> GO TO NEXT PAGE
                                </Button>
                        </Grid>

                        : null
                }

            </Grid>
        );
    }
}

//}




// WEBPACK FOOTER //
// ./src/pages/CycleOfTheReportPage.js